import { DateTime } from 'luxon';
import { PaginationRequest } from '../pagination/pagination';
import { AccountingBasis } from '../report/report';

export type GeneralLedgerAccountRequest = Omit<GeneralLedgerAccount, 'id'>;

export type GeneralLedgerAccount = {
  id: string;
  number: string;
  name: string;
  qboAccountId?: string;
  accountType: GeneralLedgerAccountType;
};

export enum ItemType {
  Product = 'Product',
  CustomProduct = 'CustomProduct',
  LocationFee = 'LocationFee',
  ProductFee = 'ProductFee',
  Upcharge = 'Upcharge',
  Refund = 'Refund',
  Freight = 'Freight',
  Coupon = 'Coupon',
  Discount = 'Discount',
  DamageWaiver = 'DamageWaiver',
  CreditCardFee = 'CreditCardFee',
}

export enum GeneralLedgerAccountType {
  Tax = 'Tax',
  Income = 'Income',
  Expense = 'Expense',
}

export enum ItemGeneralLedgerTransactionType {
  Expense = 'Expense',
  Sale = 'Sale',
  Rental = 'Rental',
}

export type ItemGeneralLedgerAccount = {
  id: string;
  itemType?: ItemType;
  itemId?: string;
  transactionType?: ItemGeneralLedgerTransactionType;
  generalLedgerAccountId?: string;
};

export type UpsertItemGeneralLedgerAccountRequest = Omit<ItemGeneralLedgerAccount, 'id' | 'generalLedgerAccountId'> & {
  generalLedgerAccountId?: string;
};

export type AccountTotalsRequest = {
  from?: DateTime;
  to?: DateTime;
  accountIds?: string[];
  accountType?: GeneralLedgerAccountType;
  hidePerLocation?: boolean;
  basis: AccountingBasis;
};

export type AccountTotalsRow = {
  'Account Name': string;
  'Account Number': string;
  'Location Totals': {
    Location: string;
    Total: number;
    'Revenue Total'?: number;
  }[];
  Total: number;
  'Revenue Total'?: number;
};

export type AccountLedgerRequest = {
  from?: DateTime;
  to?: DateTime;
  locationId?: number;
  basis: AccountingBasis;
} & PaginationRequest;

export type AvailableAccountLedgerRangeRequest = {
  locationId?: number;
};

export type AccountLedgerEntry = {
  Date: string;
  'Invoice Number': string;
  Name: string;
  Location: string;
  Description: string;
  Amount: number;
};

export type PeriodicLedgerTotalsRequest = {
  from: DateTime;
  to: DateTime;
  locationId?: number;
  period: 'day' | 'week' | 'month' | 'year';
  basis: AccountingBasis;
};

export type PeriodicLedgerTotal = {
  periodStart: DateTime;
  total: number;
};

export type CreateAccountingPeriodCloseRequest = {
  closeDateTime: DateTime;
};

export type AccountingPeriodClose = {
  id: string;
  closeDateTime: DateTime;
  createdAt: DateTime;
  createdBy?: number;
  deletedAt?: DateTime;
  deletedBy?: number;
};
